
// import { Skeleton } from './Settings';
// import { formatTimestampToDate } from './Utils';
import Request from './request';

  export const getEvents = async (params, start = 0, limit = 100) => {
    const requestParams = {
      ...params,
      filter: {
        ...params.filter,
        status: 100,
      },
      sort: {
        'id' : -1,
      },
      pagination: {
        'start' : start,
        'limit' : limit,
      }
    };
    return await Request.get('/v1/events', requestParams).then((res) => {
      return res;
    });
  };
  
  export const getEvent = async (id) => {
    let params = {};
    return await Request.get('/v1/events/' + id, params).then((res) => {
      return res;
    });
  };

  export const getEventTicketList = async (eventid) => {
    return await Request.get('/v1/events/'+eventid+'/tickets').then((res) => {
      return res;
    });
  };

  //获取票务列表
  export const getTicketList = async (eventid) => {
    return await Request.get('/v1/events/'+eventid+'/tickets').then((res) => {
      return res;
    });
  };

  export const getTicket = async (id) => {
    return await Request.get('/v1/tickets/'+id).then((res) => {
      return res;
    });
  };

  export const getOrder = async (id) => {
    return await Request.get('/v1/orders/' + id).then((res) => {
      return res;
    });
  }; 

  export const postOrder = async (params) => {
    return await Request.formpost('/v1/orders', params).then((res) => {
        return res;
    });
  };

  export const getPaychannels = async (orderid) => {
    return await Request.get('/v1/orders/' +orderid+ '/paychannels').then((res) => {
      return res;
    });
  };

  export const postCharge = async (orderid, paymentid) => {
    let params = {
      'paymentid' : paymentid,
    };
    return await Request.formpost('/v1/orders/' +orderid+ '/charge', params).then((res) => {
      return res;
    });
  };

  export const getEventHotels = async (eventid, params) => {
    return await Request.get('/v1/events/'+eventid+'/hotels', params).then((res) => {
      return res;
    });
  };

  export const getEventSettings = async (eventid) => {
    return await Request.get('/v1/events/'+eventid+'/settings').then((res) => {
      return res;
    });  
  };

  export const getEventMarkdown = async (eventid) => {
    return await Request.get('/v1/events/'+eventid+'/markdown').then((res) => {
      return res;
    });  
  };

  export const getEventRichtext = async (eventid) => {
    return await Request.get('/v1/events/'+eventid+'/richtext').then((res) => {
      return res;
    });  
  };

  export const getBadges = async (eventid, start, num, params) => {
    params.start = start;
    params.num   = num;
    params.sort  = {
      'ctime' : 'DESC'
    };
    console.log('badges:',params);
    return await Request.get('/v1/events/'+eventid+'/badges', params).then((res) => {
      return res;
    });
  };

  export const getEventFiles = async (eventid) => {
    let params = {
      'filter': {
        'status': 100
      },
      'pagination': {
        'start': 0,
        'limit': 100
      }
    };

    return await Request.get('/v1/events/'+eventid+'/files', params).then((res) => {
      return res;
    });  
  };